import { User } from '@/modules/User/interfaces/user'
export enum RecordTypeMaster {
  ACCOUNT = 'ACCOUNT',
  CONTACT = 'CONTACT',
  QUOTE = 'QUOTE',
  POLICY = 'POLICY',
  PROPERTY = 'PROPERTY'
}

export interface RecordTypeFormItem {
  keyName: string;
  type: string;
  name: string;
  options: string[];
  required: boolean;
}

export interface RecordTypeAdditionalInfo {
  title: string;
  items: RecordTypeFormItem[];
  funcs: string[];
}

export interface RecordType {
  id: number;
  name: string;
  description: string;
  master: RecordTypeMaster;
  usedTimes: number;
  additionalInfo: RecordTypeAdditionalInfo[];
  createdBy: User;
  createdAt: string;
  updatedAt: string;
  lastModifiedBy: User;
  step: number;
  status:string;
}
